<script setup>
import NavList from './Nav/List.vue';
import NavItem from './Nav/Item.vue';
import NavText from './Nav/Text.vue';
import NavIcon from './Nav/Icon.vue';

const open = defineModel('open');
const setNavOpen = (value) => open.value = value;
</script>

<style lang="postcss" scoped>
.sidenav {
    @apply h-full w-full md:w-1/2 lg:w-full;
    @apply max-lg:translate-x-[-100%] max-lg:duration-300 max-lg:fixed max-lg:rounded-l-none;
    @apply max-lg:top-0 max-lg:left-0 max-lg:z-50 bg-white text-white-foreground;
    &[data-open="true"] {
        @apply max-lg:translate-x-0;
    }
}
</style>

<template>
    <app-layout class="sidenav" :data-open="open">
        <app-layout-header>
            <app-top-nav>
                <app-icon-button v-if="$store.state.deviceType !== 'desktop'" class="-ml-4" icon="cancel" @click="setNavOpen(false)" />
            </app-top-nav>
        </app-layout-header>
        <app-layout-body class="px-4">
            <NavList>
                <NavItem to="/marketplace" @click="setNavOpen(false)">
                    <NavIcon icon="store-search-outline" />
                    <NavText>Browse</NavText>
                </NavItem>
                <NavItem v-if="$store.state.user" :to="{ name: 'marketplace.saved-listings' }" @click="setNavOpen(false)">
                    <NavIcon icon="bookmark-outline" />
                    <NavText>Saved</NavText>
                </NavItem>
                <NavItem v-if="$store.state.user" :to="{ name: 'marketplace.me.listings' }" @click="setNavOpen(false)">
                    <NavIcon icon="tag-multiple-outline" />
                    <NavText>My Listings</NavText>
                </NavItem>
                <NavItem v-if="$store.state.user" to="/marketplace/messages" @click="setNavOpen(false)">
                    <div class="relative">
                        <NavIcon icon="message-text-outline" />
                        <app-badge v-if="$store.state.unreadMarketplaceChats" class="absolute -top-2 -right-2" :count="$store.state.unreadMarketplaceChats" />
                    </div>

                    <NavText>Messages</NavText>
                </NavItem>
                <NavItem v-if="$store.state.user" :to="{ name: 'marketplace.sellers.show', params: { id: $store.state.user.id } }" @click="setNavOpen(false)">
                    <NavIcon icon="account-card-outline" />
                    <NavText>Profile</NavText>
                </NavItem>
            </NavList>

            <div class="mt-10 px-4">
                <app-button as="router-link" :to="{ name: 'marketplace.listing.create' }" full color="primary-border" @click="setNavOpen(false)">
                    <icon-plus class="size-7 shrink-0" />
                    <span>Sell</span>
                </app-button>
            </div>
        </app-layout-body>
    </app-layout>
</template>
